<template>
  <div>
    <div v-if="!data || data.length === 0" class="text-center pa-5 grey--text">
      No data available
    </div>
    <div v-else class="chart-container">
      <highcharts ref="chart" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    setTimeout(() => {
      if (!this.$refs.chart) return;
      this.$refs.chart.chart.reflow();
    }, 200);
  },
  computed: {
    chartOptions() {
      if (!this.data || this.data.length === 0) return {};

      // Group by source and build monthly series
      const sourceMap = {};
      const monthSet = new Set();

      this.data.forEach(row => {
        if (!row.sourceName) return;
        if (!sourceMap[row.sourceName]) sourceMap[row.sourceName] = {};
        const key = `${row.year}-${String(row.month).padStart(2, "0")}`;
        sourceMap[row.sourceName][key] = row.count;
        monthSet.add(key);
      });

      // Sort months chronologically
      const months = Array.from(monthSet).sort();

      // Get top 8 sources by total volume
      const sourceTotals = Object.entries(sourceMap).map(
        ([name, monthData]) => ({
          name,
          total: Object.values(monthData).reduce((s, v) => s + v, 0)
        })
      );
      sourceTotals.sort((a, b) => b.total - a.total);
      const topSources = sourceTotals.slice(0, 8).map(s => s.name);

      // Build series for top sources
      const series = topSources.map(name => ({
        name,
        data: months.map(m => sourceMap[name][m] || 0)
      }));

      // Format month labels
      const categories = months.map(m => {
        const [y, mo] = m.split("-");
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ];
        return `${monthNames[parseInt(mo) - 1]} ${y.slice(2)}`;
      });

      return Object.assign(
        {},
        {
          chart: { type: "line", height: 350 },
          title: { text: "Retained Cases by Source (12 Months)" },
          credits: { enabled: false },
          xAxis: { categories },
          yAxis: { title: { text: "Cases Retained" }, min: 0 },
          legend: { enabled: true },
          series
        }
      );
    }
  }
};
</script>

<style scoped>
.chart-container {
  height: 370px;
}
</style>
